import { useProvinces } from '@/hooks/use-address-lists'
import {
  FieldInfo,
  hasFieldError,
  readOnlyTriggerClass,
  useFieldContext,
  useFormReadOnly,
  useIsFieldOptional,
} from './shared'
import { Combobox } from '../combobox'
import { FieldLabelRow } from './field-label-row'
import { useLingui } from '@lingui/react/macro'
import { cn } from '@/lib/utils'
import { HORIZONTAL_CONTROL_CLASS, HORIZONTAL_LABEL_CLASS, HORIZONTAL_ROW_CLASS } from './horizontal-field'

// Resolves its own options from `country` (fed via form.Subscribe). Pair with `CountryField`, which clears this.
export default function ProvinceField(props: {
  label: string
  className?: string
  orientation?: 'vertical' | 'horizontal'
  optional?: boolean
  placeholder?: string
  country?: string | null
}) {
  const { t } = useLingui()
  const field = useFieldContext<string>()
  const formReadOnly = useFormReadOnly()
  const isOptional = useIsFieldOptional(field.name, props.optional)
  const isHorizontal = props.orientation === 'horizontal'

  const options = useProvinces(props.country)

  return (
    <div className={cn(props.className, formReadOnly && readOnlyTriggerClass)}>
      <div className={isHorizontal ? HORIZONTAL_ROW_CLASS : 'grid gap-2'}>
        {props.label && (
          <FieldLabelRow
            label={props.label}
            htmlFor={field.name}
            hasError={field.state.meta.isTouched && !field.state.meta.isValid}
            optional={isOptional}
            compactOptional={isHorizontal}
            className={isHorizontal ? HORIZONTAL_LABEL_CLASS : undefined}
          />
        )}
        <div className={isHorizontal ? HORIZONTAL_CONTROL_CLASS : undefined}>
          <Combobox
            id={field.name}
            placeholder={formReadOnly ? '-' : props.placeholder}
            searchPlaceholder={t`Search...`}
            commandEmpty={t`No results found`}
            options={options}
            value={field.state.value ?? ''}
            onChange={field.handleChange}
            isError={hasFieldError(field.state.meta)}
          />
          <FieldInfo fieldState={field.state} />
        </div>
      </div>
    </div>
  )
}
